export default (theme) => ({
  gridRoot: {
    backgroundColor: 'white',
    flex: 1,
    overflow: 'auto',
    padding: '0 1em',
  },
  footer: {
    display: 'flex',
    padding: '.5em',
    justifyContent: 'flex-end',
  },
  container: {
    width: '340px',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    '@media print': { display: 'none' },
  },
  containerFullScreen: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  containerTitle: {
    padding: '.5em .5em .5em 1em',
    display: 'flex',
  },
  title: {
    flex: 1,
    margin: 0,
    lineHeight: '38px',
  },
  close: { fontSize: '14px' },
  drawerOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    '@media print': { display: 'none' },
  },
  drawerOpenFullScreen: {
    width: '100%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '@media print': { display: 'none' },
  },
  drawerClose: {
    overflowX: 'hidden',
    width: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up('sm')]: { width: 0 },
    '@media print': { display: 'none' },
  },
});
